<template>
  <div class="box-outer">
    <label v-if="label" :for="`id_${name}`" class="label">{{ label }}</label>
    <textarea
      v-if="name"
      :id="`id_${name}`"
      :name="name"
      :placeholder="placeholder"
      :value="value"
      :class="{ 'input-error': errors.length }"
      rows="1"
      class="input"
      @input="handleInput"
      @blur="handleInput"
    />
    <error-component :errors="errors"/>
  </div>
</template>

<script>
import ErrorComponent from '@/components/Error'

export default {
  components: {
    ErrorComponent
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    errors: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleInput (evt) {
      let value = evt.target.value
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.box-outer {
  margin: 28px 0 0;

  .field &,
  .fields-wrap & {
    margin: 0;
  }
}

.label {
  @include label;
}

.input {
  @include input;

  padding: 18px;
  height: auto;
}

.input-error {
  border: 2px solid $error;
}
</style>
